import Cookies from "js-cookie";

const baseUrl = "/services/login/api";
const XSRF_TOKEN_COOKIE_NAME = "XSRF-TOKEN";

class LoginService {
    async getDebtNumber() {
        const response = await fetch(baseUrl + "/user/debtNumber", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const debtNo = await this.handleResponse(response);
        return debtNo.text();
    }

    async loginWithDebtNumber(debtNumber: string): Promise<string> {
        const formData = new URLSearchParams();
        formData.append("debtNumber", debtNumber);

        const response = await fetch(baseUrl + "/token/debt", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-XSRF-TOKEN": Cookies.get(XSRF_TOKEN_COOKIE_NAME) as string,
            },
            body: formData,
        });

        const result = await this.handleResponse(response);
        return result.headers.get("Location") as string;
    }

    async logout() {
        const response = await fetch(baseUrl + "/token/logout", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-XSRF-TOKEN": Cookies.get(XSRF_TOKEN_COOKIE_NAME) as string,
            },
        });
        console.log("Logout", response);
    }

    async handleResponse(response: Response) {
        if (response.ok) {
            return response;
        }
        if (response.status !== null || response.status !== " ") {
            throw new Error(response.status.toString());
        }
        throw new Error();
    }
}

export default new LoginService();
